import { useRoute } from "vue-router"

import { useStore } from "@/store"

import { HtmlUtils } from "../utils/html.utils"
import { PathUtils } from "../utils/path.utils"
import { query } from "vue-gtag"
import { baseQuery } from "@/queries"

export const useKirby = () => {
  let kirbyUrl = PathUtils.strip(import.meta.env.VITE_KIRBY_URL)

  const getJson = async <T>(uri: string) => {
    const resp = await fetch(`${kirbyUrl}/${uri}.json`).catch(e => {
      throw new Error("Failed to fetch Kirby JSON")
    })

    return (await resp.json()) as T
  }

  const API = PathUtils.strip(import.meta.env.VITE_KIRBY_URL) + "/api/query"
  const siteQuery = {
    query: "site",
    select: {
      title: true,
      children: {
        query: "site.children",
        select: baseQuery,
      },

      programmeRoutes: {
        query: "page('programmes').children",
        select: ["uri"],
      },

      footerLinks: {
        query: "site.footerLinks.toStructure",
      },

      programmeGroups: {
        query: "page('programmes').structure.toStructure",
        select: {
          id: "structureItem.id",
          title: "structureItem.title",
          courses: {
            query: "structureItem.pages.toPages.sortBy('title')",
            select: baseQuery,
          },
        },
      },
    },
  }

  const getSite = async () => {
    const response = await fetch(API, {
      method: "post",
      body: JSON.stringify(siteQuery),
    }).catch(e => {
      throw new Error("Failed to fetch Kirby JSON")
    })
    const json = await response.json().catch(e => {
      throw new Error("Failed to parse Kirby JSON")
    })

    return json.result
  }

  const getPage = async <T>(path: string) => {
    const page = await getJson<T>(PathUtils.toPageUri(path))

    // fix relative links
    HtmlUtils.modifyPageHtml(page, (html: any) => {
      for (const a of html.getElementsByTagName("a")) {
        a.href = a
          .getAttribute("href")
          .replace(
            PathUtils.strip(useStore().state.api),
            "/" + PathUtils.strip(import.meta.env.VITE_BASE_URL),
          )
      }
    })

    return page
  }

  return {
    getSite,
    getPage,
  }
}
